<!-- 销售控销数据操作 -->
<template>
    <div>
        <div v-if="isLoaded">
            <div class="demo-drawer__content data_action_form">
                <div class="page_title">
                    <el-alert :title="dataActionBox.boxTitle" type="success" effect="dark" :closable="false">
                    </el-alert>
                </div>
                <el-tabs type="border-card" v-model="showTabs" class="el-tabs--border-card_new" v-if="tabForm">
                    <el-tab-pane v-for="(formListValue, formKey) in tabForm" :key="formKey" :label="formListValue.jciName"
                        :name="formListValue.jciName">
                        <div class="table_content_box">
                            <!-- 主要信息 -->
                            <div v-if="formKey == 0">
                                <el-form label-width="150px" id="mainInfo" class="baseForm" :model="sendDataInfo"
                                    ref="sendDataInfo" size="mini" :show-message="false">
                                    <el-row v-if="dataActionBox.actionType != 2">
                                        <el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow == 1"
                                            v-for="(formOneValue, formOneKey) in formListValue.jurconfigform"
                                            :key="formOneKey" :prop="formOneValue.entityField"
                                            :rules="formOneValue.isRequired == 0 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                            <!-- 日期 -->
                                            <df-date v-if="formOneValue.entityField == 'psomBuydate'"
                                                @keyup.enter.native="nextFocus(formOneKey)"
                                                v-model="sendDataInfo[formOneValue.entityField]"
                                                :isdisabled="formOneValue.isChange == 0 || (sendDataInfo.pisOrderDetail.length > 0 && formOneValue.isUpdate == 0)">
                                            </df-date>
                                            <df-date v-else-if="formOneValue.fieldType == 'date'" :isShowLong="false"
                                                v-model="sendDataInfo[formOneValue.entityField]"
                                                @keyup.enter.native="nextFocus(formOneKey)"
                                                :isdisabled="formOneValue.isChange == 0 || (sendDataInfo.pisOrderDetail.length > 0 && formOneValue.isUpdate == 0)"></df-date>
                                            <!-- 检索方案 -->
                                            <el-input v-else-if="formOneValue.fieldType == 'search'" clearable
                                                v-model="sendDataInfo[formOneValue.entityField]"
                                                :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                                :disabled="formOneValue.isChange == 0 || (sendDataInfo.pisOrderDetail.length > 0 && formOneValue.isUpdate == 0) || dataActionBox.actionType == 2">
                                                <el-button
                                                    @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                                    slot="append" icon="el-icon-search"
                                                    :disabled="formOneValue.isChange == 0 || (sendDataInfo.pisOrderDetail.length > 0 && formOneValue.isUpdate == 0) || dataActionBox.actionType == 2">
                                                </el-button>
                                            </el-input>
                                            <!-- formatter下拉选   :automatic-dropdown="true"-->
                                            <el-select clearable size="mini"
                                                v-else-if="formOneValue.fieldType == 'formatter'"
                                                @visible-change="selectChange" @change="$forceUpdate()"
                                                v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择"
                                                :disabled="formOneValue.isChange == 0 || (sendDataInfo.pisOrderDetail.length > 0 && formOneValue.isUpdate == 0)">
                                                <el-option v-for="item in JSON.parse(formOneValue.formatterContent)"
                                                    :key="item.key" :label="item.value" :value="item.key">
                                                </el-option>
                                            </el-select>
                                            <!-- string类型 -->
                                            <el-input
                                                :disabled="formOneValue.isChange == 0 || (sendDataInfo.pisOrderDetail.length > 0 && formOneValue.isUpdate == 0)"
                                                @keyup.enter.native="nextFocus(formOneKey)" v-else
                                                v-model.trim="sendDataInfo[formOneValue.entityField]"
                                                :maxlength="$store.state.inputLength"></el-input>
                                        </el-form-item>
                                    </el-row>
                                    <el-row v-if="dataActionBox.actionType == 2">
                                        <el-form-item :label="formOneValue.showField + ':'" v-if="formOneValue.isShow == 1"
                                            v-for="(formOneValue, formOneKey) in formListValue.jurconfigform"
                                            :key="formOneKey">
                                            <span v-if="formOneValue.isRift == 1">
                                                <a
                                                    @click="toDetail(sendDataInfo[formOneValue.riftField])">{{ sendDataInfo[formOneValue.entityField] }}</a>
                                            </span>
                                            <span v-else-if="formOneValue.fieldType == 'date'">
                                                <span v-if="sendDataInfo[formOneValue.entityField]">
                                                    {{
                                                        $common.getLocalTime(sendDataInfo[formOneValue.entityField])
                                                    }}
                                                </span>
                                            </span>
                                            <span
                                                v-else-if="formOneValue.entityField == 'isWms' || formOneValue.entityField == 'isPay'">{{
                                                    sendDataInfo[formOneValue.entityField] == 1 ? "是" : "否"
                                                }}</span>
                                            <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                        </el-form-item>
                                    </el-row>
                                </el-form>
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
                <!-- 明细信息 -->
                <div>
                    <el-form :inline="true" size="mini" :data="sendDataInfo.pisOrderDetail" :row-class-name="rowClassName"
                        :row-style="rowStyle" @selection-change="handleSelectionChange" border style="width: 100%"
                        :height="mxHeight" @submit.native.prevent>
                        <div style="margin-bottom: 0.5rem;">
                            <el-button type="primary" size="mini" @click="addDetail('sendDataInfo')">
                                新增</el-button>
                            <el-button type="danger" size="mini" @click="deleteDetails()">删除
                            </el-button>
                        </div>
                        <el-table size="mini" class="baseTable" ref="mxTableRef" :data="sendDataInfo.pisOrderDetail" border
                            style="width: 100%">
                            <el-table-column label="选择操作" width="80">
                                <template slot-scope="scope">
                                    <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                                        <i class="el-icon-thumb"></i>
                                    </el-radio>
                                </template>
                            </el-table-column>
                            <el-table-column prop="cpdtName" label="内容" show-overflow-tooltip width="300">
                                <template slot-scope="scope">
                                    <el-input clearable v-model="sendDataInfo.pisOrderDetail[scope.$index].cpdtValue"
                                        @keyup.enter.native="openSearch('', scope.$index, '', '')">
                                        <el-button @click="openSearch('', scope.$index, '', '')" slot="append"
                                            icon="el-icon-search">
                                        </el-button>
                                    </el-input>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-form>
                </div>
                <div class="foot">
                    <div>
                        <el-button v-if="dataActionBox.actionType == 2 && $common.checkIsPrint()" type="primary"
                            @click="showPrintPlan">打印
                        </el-button>
                        <el-button v-if="dataActionBox.actionType != 2" type="primary"
                            @click="initActionBox('sendDataInfo', 'pisOrderAuxinf')">取消</el-button>
                        <el-button type="primary" @click="sendDataAction('sendDataInfo', 'pisOrderAuxinf')"
                            v-if="dataActionBox.actionType == 0">保存</el-button>
                        <el-button type="primary" @click="sendDataAction('sendDataInfo', 'pisOrderAuxinf')"
                            v-if="dataActionBox.actionType == 1">保存</el-button>
                    </div>
                    <el-form :inline="true" :model="sendDataInfo" class="demo-form-inline ml" v-if="footForm">
                        <el-form-item :label="itemV.chineseField" v-for="(itemV, itemK) in footForm" :key="itemK">
                            <el-button type="success">{{ sendDataInfo[itemV.entityField] }}</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>

        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth"
            :modal-append-to-body='true' :append-to-body="true" @close="closeChild">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel"
                @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
    </div>
</template>
 
<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import SearchScheme from "../byComponents/SearchScheme.vue";
export default {
    name: "limitCustomersAction",
    props: ["actionData"],
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
    },
    data() {
        //这里存放数据
        return {
            mxHeight: 0,
            guaranteeBeginDay: "",
            detailRules: false, //规则
            ruleDisabled: false,
            selectDataTable: false,
            showControlPin: false,
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            formData: {
                resource: "0",
                quantity: 0,
            },
            selectedDetailsIndex: 0,
            value1: "",
            newsendDataInfo: {
                bgmId: 0,
                bgsId: 0,
                cpmId: 0,
                controlNum: 0,
                controlType: 0,
                controlRule: [],
            },
            sendDataInfo: {
                bgmId: 0,
                bgsId: 0,
                cpmId: 0,
                bgmName: "",
                controlType: 0,
                num: 0,
                spec: "",
                manufacturer: "",
                placeorigin: "",
                batchno: "",
                prodate: 0,
                expidate: 0,
                bgiRegistno: 0,
                controlNum: 0,
                controlContent: '',
                pisOrderDetail: [],
                controlRule: [],

                // coName: "",
                // coId: "",
                // payMethod: "",
                // settleMethod: "",
                // psaiAccperiod: "",
                // psaiCarricus: "",
                // psaiCarrier: "",
                // psaiDeptime: "",
                // psaiExptime: "",
                // psaiPaymethod: "",
                // psaiReserves1: "",
                // psaiReserves2: "",
                // psaiReserves3: "",
                // psaiReserves4: "",
                // psaiReserves5: "",
                // psaiReserves6: "",
                // psaiSettmethod: "",

                // controlGoodTempAdds: [],
                // psomBusdept: 0,
                // smId: 0,
                // smName: "",
                // psomBuydate: 0,
                // psomBuydateval: 0,
                // isWms: "",
                // opmId: 0,
                // opmName: "",
                // psomRemark: "",
                // psomReserves1: "",
                // psomReserves2: "",
                // psomReserves3: "",
                // psomReserves4: "",
                // psomReserves5: "",
                // psomReserves6: "",
                // salesId: "",
                // salesName: "",
                // totalCount: 0,
                // totalMoney: 0,
                // totalNumber: 0,
                // psaiId: "",
                // psomId: "",
                // depId: "",
                // depName: "",
                // isPay: "",
                // sbiName: "",
                // sbiNumber: "",
                // sbiId: "",
                // spec: '',
                // manufacturer: '',
                // scopeName: '',
                // placeorigin: '',
                // mne: '',
            },
            showTabs: "",
            formDataList: [],
            dictionariesData: {},
            userOneList: [],
            goodsList: [],
            storageRoomList: [],
            salesmanList: [],
            editDateilsIndex: "",
            exId: "",
            seId: "",
            ceshi: "",
            dialogTitle: "",
            seWidth: "",
            height: "",
            exTitle: "",
            seTitle: "",
            seWidth: "",
            exWidth: "",
            DialogVisible: false,
            DialogExtract: false,
            newFormDataList: [],
            seType: "",
            smId: "",
            parentSearchData: {
                smId: "",
                orderType: 1, //	订单类型0.药品1.器械
                dtId: "",
            },
            isLoaded: false,
            orderId: "",
            printsouce: "",
            seIndex: 0, //选中索引
            isBuyer: 0,
            tabForm: [], // tab循环的主表单
            sField: "", // 赋值字段
            fField: "", //焦点字段
            nosField: "", // 不可赋值字段
            mxForm: [],
            footForm: [],
            selectedRow: [],
            mainFormPin: [], //维护控销数据
            controlGoodTempAdds: [], //
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        // "parentSearchData.smId": {
        //    handler: function (newValue, oldValue) {
        //       console.log("smId=======", newValue);
        //    },
        //    deep: true,
        // },
    },
    //方法集合
    methods: {
        //新增规则
        addDetail(sendDataInfo) {
            this.$refs[sendDataInfo][0].validate((valid) => {
                if (valid) {
                    if (
                        Number(this.sendDataInfo.controlNum) >
                        Number(this.sendDataInfo.num)
                    ) {
                        this.$message({
                            message: "控销数量超出库存数量",
                            type: "error",
                        });
                        return;
                    }
                    this.sendDataInfo.pisOrderDetail.push({
                        cmId: "",
                        cpdtValue: "",
                    });
                    this.$nextTick(() => {
                        this.selectedDetailsIndex = Number(
                            this.sendDataInfo.pisOrderDetail.length - 1
                        );
                        // this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                        let refsElTable = this.$refs.mxTableRef;
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(
                            this.sendDataInfo.pisOrderDetail[this.selectedDetailsIndex]
                        );
                    });
                } else {
                    return this.$message({
                        message: "请完善必填信息",
                        type: "warning",
                    });
                }
            });
        },

        //删除规则
        deleteDetails() {
            if (this.sendDataInfo.pisOrderDetail.length < 1) {
                return this.$message({
                    message: "暂无可删除明细",
                    type: "warning",
                });
            }

            this.sendDataInfo.pisOrderDetail.splice(this.selectedDetailsIndex, 1);
            if (this.sendDataInfo.pisOrderDetail.length > 1) {
                this.selectedDetailsIndex = Number(this.selectedDetailsIndex - 1);
            } else {
                this.selectedDetailsIndex = 0;
            }
            // this.tableNextFocus("bgmName", this.selectedDetailsIndex);
            let refsElTable = this.$refs.mxTableRef;
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(
                this.sendDataInfo.pisOrderDetail[this.selectedDetailsIndex]
            );
        },
        closeChild() {
            addEventListener("keyup", this.keyUp); //创建监听键盘事件
        },
        // 保存已选择行
        handleSelectionChange(rows) {
            this.selectedRow = rows; // 保存已选择行
        },
        // 表格方法
        rowClassName({ row, rowIndex }) {
            let rowName = "",
                findRow = this.selectedRow.find((c) => c.rowIndex === row.rowIndex);
            if (findRow) {
                rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
            }
            return rowName; //也可以再加上其他类名 如果有需求的话
        },
        // 选中行底色逻辑
        rowStyle({ row, rowIndex }) {
            Object.defineProperty(row, "rowIndex", {
                // 给每行添加不可枚举属性rowIndex来标识当前行
                value: rowIndex,
                writable: true,
                enumerable: false,
            });
            let rowBackground = {};
            if (row.bgColor && row.bgColor != "")
                rowBackground.backgroundColor = row.bgColor;
            return rowBackground;
        },
        // 主表单select框切换enter切换焦点事件方法
        selectChange(e) {
            if (e == false) {
                this.sendDataInfo.pisOrderDetail = [];
                // this.newsendDataInfo.controlType=this.sendDataInfo.controlContent
            }
        },

        // 初始化焦点
        initFocus() {
            for (let index = 0; index < this.inputel.length; index++) {
                if (this.inputel[index].value == "") {
                    this.inputel[index].focus();
                    break;
                }
            }
        },

        // 表格切换焦点方法
        // tableNextFocus(field, index) {
        //    console.log(field);
        //    if (field == "keydown") {
        //       if (this.sendDataInfo.pisOrderDetail[index + 1] != undefined) {
        //          this.$refs["bgmName"][index + 1].focus();
        //          return;
        //       }
        //       this.addDetail("sendDataInfo");
        //       return;
        //    }
        //    this.$refs[field][index].focus();
        // },
        showPrintPlan() {
            // 打印方法
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                console.log(this.actionData);
                this.$refs.printPlan.openDia(
                    this.actionData.orderId,
                    this.actionData.printSouce,
                    this.actionData.printJurId
                );
            } else {
                return;
            }
        },
        toDetail(orderId) {
            this.$parent.$parent.$parent.toDetail(orderId);
        },
        //换行提示
        lineMessageBox(data) {
            let txtArr = data.message.split("<br/>");
            let newArr = [];
            const h = this.$createElement;
            for (const i in txtArr) {
                newArr.push(h("p", null, txtArr[i]));
            }
            this.$alert(h("div", null, newArr), "提示", {
                confirmButtonText: "确定",
                callback: (action) => { },
            });
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.sendDataInfo[item] = val[item];
            });
            this.$nextTick(() => {
                this.nextFocus(this.seIndex);
            });
        },
        // 表格赋值字段
        mxParamValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.sendDataInfo.pisOrderDetail[this.seIndex][item] = val[item];
            });
            this.$nextTick(() => {
                this.tableNextFocus(this.fField, this.seIndex);
            });
        },
        // 清除赋值字段数据
        clearValue() {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.sendDataInfo[item] = "";
            });
        },
        //提取返回
        changeInputModel(val) {
            console.log("返回", val);
            if (val != "" && val != undefined) {
                this.DialogVisible = false;
                addEventListener("keyup", this.keyUp); //创建监听键盘事件
                if (val.depId) {
                    this.sendDataInfo.depId = val.depId;
                    this.sendDataInfo.depName = val.depName;
                }
                if (this.seType == "bgmName") {
                    for (let key in val) {
                        this.sendDataInfo[key] = val[key];
                    }
                } else if (this.seType == "dw") {
                    this.sendDataInfo.pisOrderDetail[this.seIndex].cmId = val.cmId;
                    this.sendDataInfo.pisOrderDetail[this.seIndex].cpdtValue =
                        val.cmName;
                    this.sendDataInfo.pisOrderDetail.splice(1, 0);
                } else if (this.seType == "dq") {
                    this.sendDataInfo.pisOrderDetail[this.seIndex].cmId = val.diId;
                    this.sendDataInfo.pisOrderDetail[this.seIndex].cpdtValue =
                        val.diName;
                    this.sendDataInfo.pisOrderDetail.splice(1, 0);
                } else {
                    this.paramValue(val);
                }
            }
            // this.sendDataInfo.pisOrderDetail[this.seIndex].bgmName = val.bgmName
            this.changeFocus();
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getWidth(e) {
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        getExtractName(e) {
            this.exTitle = e;
        },
        // 检索Id, 索引(表格中), 标识
        //        检索Id, 索引， 字段名，赋值字段，焦点字段, 不可赋值字段
        openSearch(sId, index, type, sField, fField, nosField) {
            this.DialogVisible = true;
            removeEventListener("keyup", this.keyUp);
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = sField;
            this.fField = fField;
            console.log(this.sendDataInfo.controlType, 'this.sendDataInfo.controlType');
            if (type == "bgmName") {
                this.seId = sId;
                this.seIndex = index;
                this.seType = type;
                this.sField = sField;
                this.fField = fField;
            } else if (this.sendDataInfo.controlType == 0) {
                this.seId = "3391151360249856";
                this.seType = "dw";
            } else if (this.sendDataInfo.controlType == 1) {
                this.seId = "8820873997127687";
                this.parentSearchData.dtId = "38";
                this.seType = "dq";
                console.log(12121212);
            } else if (this.sendDataInfo.controlType == 2) {
                this.seId = "8820873997127687";
                this.parentSearchData.dtId = "48";
                this.seType = "dq";
            }
            console.log(sId);

            // if (type == "bgmName") {
            //    this.parentSearchData.stId = this.sendDataInfo.stId;
            //    this.parentSearchData.cmId = this.sendDataInfo.cmId;
            //    this.parentSearchData.coId = this.sendDataInfo.coId;

            //    this.parentSearchData.bgmName = this.sendDataInfo.bgmName;
            //    return;
            // }
            this.parentSearchData[type] = this.sendDataInfo[type];
        },
        tableRowClassName({ row, rowIndex }) {
            row.index = rowIndex;
        },
        initActionBox(sendDataInfo) {
            var cancelTitle = this.dataActionBox.actionType == 0 ? "新增" : "修改";
            this.$confirm("确定取消" + cancelTitle + "吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$emit("drawerCancel", 0);
                    // this.$parent.getDataList()
                    this.init();
                    this.$refs[sendDataInfo][0].resetFields();
                    this.mainFormPin = [];
                    sessionStorage.removeItem("setPin1");
                    sessionStorage.removeItem("allAndself");
                })
                .catch(() => { });
        },
        init() {
            for (let key in this.sendDataInfo) {
                if (key == "pisOrderAuxinf") {
                    for (let sonOne in this.sendDataInfo[key]) {
                        this.sendDataInfo[key][sonOne] = "";
                    }
                } else if (key == "controlType") {
                    this.sendDataInfo[key] = 0;
                } else if (key == "pisOrderDetail") {
                    this.sendDataInfo[key] = [];
                } else {
                    this.sendDataInfo[key] = "";
                }
            }

            // this.sendDataInfo.psomBuydate = this.$moment().valueOf();

            //  this.sendDataInfo.pisOrderDetail = [];
            //  this.sendDataInfo.totalMoney = 0;
            //  this.sendDataInfo.totalNumber = 0;
            //  this.sendDataInfo.totalCount = 0;
            //  this.sendDataInfo.orderType = 1; //orderType	订单类型0.药品订单1.器械订单
        },
        async isShowData(name, value) {
            switch (name) {
                case "supplier":
                    var dataInfo = sessionStorage.getItem("selectSupplierData");
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo);
                        this.sendDataInfo.smId = dataInfo.smId;
                        this.sendDataInfo.smName = dataInfo.smName;
                    }
                    this.sendDataInfo.salesId = "";
                    break;
                case "cargoOwner":
                    var dataInfo = sessionStorage.getItem("selectCargoOwnerData");
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo);
                        this.sendDataInfo.pisOrderAuxinf.coId = dataInfo.coId;
                        this.sendDataInfo.pisOrderAuxinf.coName = dataInfo.coName;
                    }
                    break;
            }
        },
        changeFocus() {
            setTimeout(() => {
                var el = document.getElementById("mainInfo");
                var inel = el.getElementsByClassName("el-input__inner");
                for (let index = 0; index < inel.length; index++) {
                    if (inel[index].value == "") {
                        console.log(inel[index]);
                        inel[index].focus();
                        break;
                    }
                }
            }, 500);
        },
        // 获取主表单所有input
        getMainInput() {
            var el = document.getElementById("mainInfo");
            if (el) this.inputel = el.getElementsByTagName("input");
        },
        openBox() {
            this.dataActionBox.actionType = this.actionData.cate;

            this.formDataList = this.actionData.formData;
            this.filterMainField();
            var oldData = this.actionData.oldData;
            this.showTabs = this.actionData.formData[0].jciName;
            this.init();
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = "新增信息";
                this.dataActionBox.openMode = "ltr";
                this.parentSearchData.smId = "";
                this.initDefaultValue();
                this.sendDataInfo.psomBuydate = this.$moment().valueOf();
                this.sendDataInfo.psaiDeptime = this.$moment().valueOf();
                this.sendDataInfo.psaiExptime = this.$moment().valueOf();
            } else if (this.dataActionBox.actionType == 1) {
                this.dataActionBox.boxTitle = "编辑信息";
                this.dataActionBox.openMode = "rtl";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.sendDataInfo[key] = dataInfo[key];
                }
                console.log(this.sendDataInfo, " this.sendDataInfo");
                this.smId = dataInfo.smId;
                this.parentSearchData.smId = oldData.smId;
                this.sendDataInfo.pisOrderDetail = JSON.parse(JSON.stringify(oldData.controlRule));
                this.$nextTick(() => {
                    // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
                    // this.selectedDetailsIndex = 0;
                    // let refsElTable = this.$refs.mxTableRef[0];
                    // refsElTable.clearSelection();
                    // refsElTable.toggleRowSelection(
                    //    this.sendDataInfo.pisOrderDetail[this.selectedDetailsIndex]
                    // );
                });
            } else {
                this.dataActionBox.boxTitle = "查看信息";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.sendDataInfo[key] = dataInfo[key];
                }
            }

            //  this.$nextTick(() => {
            //     var sheight = this.$refs.sendDataInfo[0].$el.clientHeight;
            //     if (this.dataActionBox.actionType != 2) {
            //        this.mxHeight =
            //           document.documentElement.clientHeight - sheight - 230;
            //     } else {
            //        this.mxHeight =
            //           document.documentElement.clientHeight - sheight - 260;
            //     }
            //  });
            this.changeFocus();
        },
        // 默认值
        initDefaultValue() {
            let arr = this.formDataList[0].jurconfigform;
            arr.forEach((item) => {
                if (
                    item.defaultValue != "null" &&
                    item.defaultValue != null &&
                    item.defaultValue != ""
                ) {
                    this.sendDataInfo[item.entityField] = item.defaultValue;
                }
            });
            this.sendDataInfo.isPay = Number(this.sendDataInfo.isPay);
            this.sendDataInfo.isWms = Number(this.sendDataInfo.isWms);
            this.sendDataInfo.psomBuydate = this.$moment().valueOf();
            this.sendDataInfo.psaiDeptime = this.$moment().valueOf();
            this.sendDataInfo.psaiExptime = this.$moment().valueOf();
        },
        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = [];
            this.formDataList.forEach((item) => {
                if (item.jciType == 1) {
                    mainFormList.push(item);
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item));
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
                }
            });
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key));
                this.tabForm[i].jurconfigform = [];
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    if (
                        key.jurconfigform[index].isShow == 1 ||
                        key.jurconfigform[index].entityField == "sbiName" ||
                        key.jurconfigform[index].entityField == "sbiNumber"
                    )
                        this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
                }
            });
        },
        //确认新增
        sendDataAction(formName1) {
            let flag = false;
            this.$refs[formName1][0].validate((valid) => {
                if (valid) {
                    console.log("sendDataInfo", this.sendDataInfo);
                    this.sub();
                } else {
                    this.$message({
                        message: "请完善主表单必填信息",
                        type: "error",
                    });
                    flag = true;
                    return false;
                }
            });
        },
        async sub() {
            if (this.sendDataInfo.pisOrderDetail.length < 1) {
                this.$message({
                    message: "请维护规则",
                    type: "error",
                });
                return;
            }
            if (
                Number(this.sendDataInfo.controlNum) > Number(this.sendDataInfo.num)
            ) {
                this.$message({
                    message: "控销数量超出库存数量",
                    type: "error",
                });
                return;
            }
            for (const key in this.newsendDataInfo) {
                this.newsendDataInfo[key] = this.sendDataInfo[key];
            }

            this.newsendDataInfo.controlRule = this.sendDataInfo.pisOrderDetail;
            console.log(this.newsendDataInfo);
            if (this.dataActionBox.actionType == 0) {
                var responseData = await this.$http.addpscontrol(
                    this.newsendDataInfo
                );
            }
            else {
                var responseData = await this.$http.updatepscontrol(
                    this.newsendDataInfo
                );
            }
            if (responseData.status == 200) {
                this.init();
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                this.$emit("drawerCancel", 1);
                this.mainFormPin = [];
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 复制
        copyDetails() {
            if (this.sendDataInfo.pisOrderDetail.length < 1) {
                return this.$message({
                    message: "暂无可复制明细",
                    type: "warning",
                });
                return false;
            } else {
                this.sendDataInfo.pisOrderDetail.push(
                    JSON.parse(
                        JSON.stringify(
                            this.sendDataInfo.pisOrderDetail[this.selectedDetailsIndex]
                        )
                    )
                );
            }
        },
        // 判断是不是采购员
        checkIsBuyer() {
            if (this.dataActionBox.actionType != 0) return;
            let info = JSON.parse(sessionStorage.getItem("userInfo"));
            if (info.opmBuyer == 1) {
                this.isBuyer = 1;
                this.sendDataInfo.depName = info.depName;
                this.sendDataInfo.depId = info.depId;
                this.sendDataInfo.opmName = info.opmName;
                this.sendDataInfo.opmId = info.opmId;
            }
        },
        // 监听键盘事件
        keyUp(e) {
            if (e.key == "F1") {
                // 右键新增明细
                e.preventDefault();
                return;
            } else if (e.key == "F2") {
                e.preventDefault();
            } else if (e.keyCode == 40) {
                // 下键
                // 表格为空，不执行下方
                if (this.sendDataInfo.pisOrderDetail.length == 0) return;
                let refsElTable = this.$refs.mxTableRef[0];
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) {
                        // 如果当前没有选中行，则直接选中第一个
                        this.selectedDetailsIndex = 0;
                    } else if (
                        this.selectedDetailsIndex ==
                        this.sendDataInfo.pisOrderDetail.length - 1
                    ) {
                        // 如果选中的是最后一行了，那么下一行选中的是第一行
                        this.selectedDetailsIndex = 0;
                    } else {
                        // 正常递增
                        this.selectedDetailsIndex++;
                    }
                    if (!refsElTable) return;
                    let findRow = this.selectedRow.find(
                        (c) => c.rowIndex == this.selectedDetailsIndex
                    ); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(
                            this.sendDataInfo.pisOrderDetail[
                            this.selectedDetailsIndex
                            ],
                            false
                        );
                        return;
                    }
                    // this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(
                        this.sendDataInfo.pisOrderDetail[this.selectedDetailsIndex]
                    ); // 把现在当前行勾选
                });
            } else if (e.keyCode == 38) {
                // 上键
                if (this.sendDataInfo.pisOrderDetail.length == 0) return;
                let refsElTable = this.$refs.mxTableRef[0];
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) {
                        // 当前没有选中行，则直接选中第一个
                        this.selectedDetailsIndex = 0;
                    } else if (this.selectedDetailsIndex == 0) {
                        // 如果选中的是第一行了，那么下一行选中的是最后一行
                        this.selectedDetailsIndex =
                            this.sendDataInfo.pisOrderDetail.length - 1;
                    } else {
                        // 正常递减
                        this.selectedDetailsIndex--;
                    }
                    if (!refsElTable) return;
                    let findRow = this.selectedRow.find(
                        (c) => c.rowIndex == this.selectedDetailsIndex
                    ); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(
                            this.sendDataInfo.pisOrderDetail[
                            this.selectedDetailsIndex
                            ],
                            false
                        );
                        return;
                    }
                    // this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(
                        this.sendDataInfo.pisOrderDetail[this.selectedDetailsIndex]
                    ); // 把现在当前行勾选
                });
            }
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.$nextTick(() => {
            this.openBox();
            this.checkIsBuyer();
            this.isLoaded = true;
        });
            this.$dbCache.Record_Get(4).then((res) => {
            //明细拦截
            let obj = res
            if (obj.isEnable == 1) this.detailRules = true;
        });
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        // addEventListener('keydown', this.keyDown)
        addEventListener("keyup", this.keyUp); //创建监听键盘事件
    },
    beforeDestroy() {
        removeEventListener("keyup", this.keyUp);
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        this.getMainInput();
    }, //生命周期 - 更新之后
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
 
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    /* height: 500px !important; */
    overflow-y: auto;
}

.el-row {
    display: flex;
    flex-wrap: wrap;
    padding-right: 20px;
}

.foot {
    display: flex;
    justify-content: center;
    align-items: center;
    /* position: absolute;
     bottom: -27px;
     left: 49%;
     transform: translate(-50%, -50%); */
    width: 100%;
    background: #fff;
    padding: 14px 0;
    z-index: 999;
}

.foot .el-form {
    margin-left: 20px;
}

.foot .el-form .el-form-item {
    margin-bottom: 0;
}

.el-drawer {
    outline: none;
}

.v-modal {
    position: static !important;
    width: 100%;
    height: 100%;
    background: transparent;
}</style>